// extracted by mini-css-extract-plugin
export default {"filterSpinner":"Report_filterSpinner__AsLLz"};